// src/components/RequireAuth.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';

export const RequireAuth = ({ children, requireAdmin = false }) => {
  // جلب بيانات المستخدم
  const userStr = localStorage.getItem('user');
  let user = {};
  
  try {
    user = userStr ? JSON.parse(userStr) : {};
  } catch (error) {
    console.error('Error parsing user data:', error);
    user = {};
  }
  
  // التحقق من المصادقة
  if (!user.isAuthenticated) {
    // حفظ الصفحة الحالية للعودة إليها بعد تسجيل الدخول
    const currentPath = window.location.pathname + window.location.search;
    localStorage.setItem('redirectAfterLogin', currentPath);
    
    return <Navigate to="/auth" replace state={{ from: currentPath }} />;
  }
  
  // التحقق من صلاحيات المسؤول إذا مطلوبة
  if (requireAdmin && !user.is_admin) {
    // عرض رسالة للمستخدم
    alert('عذراً، هذه الصفحة متاحة للمسؤولين فقط');
    
    // تسجيل محاولة الوصول غير المصرح بها (اختياري)
    console.warn(`Unauthorized access attempt to admin page by user: ${user.email}`);
    
    return <Navigate to="/" replace />;
  }
  
  // إذا تم اجتياز جميع التحققات، عرض المكون
  return children;
};